import { FeatureFlags, FeatureFlagsServiceBase } from "@skylab-shared/config";
import { Singleton } from "@skylab-shared/utils";
import { AvailabilityService, availabilityCheckerFactory } from "./availability";

@Singleton
class FeatureAvailabilityBase extends AvailabilityService<keyof FeatureFlags> {
	private features: FeatureFlags;

	protected async onRegisterAsync(
		featureFlagsService: FeatureFlagsServiceBase
	): Promise<void> {
		this.features = featureFlagsService.flags;
	}

	protected onCheck(features: keyof FeatureFlags | (keyof FeatureFlags)[]): boolean {
		if (Array.isArray(features)) {
			return features.reduce((pV, cV) => pV && !!this.features[cV], true);
		} else {
			return !!this.features[features];
		}
	};
};

export const FeatureAvailability = new FeatureAvailabilityBase();
export const withFeature = availabilityCheckerFactory(FeatureAvailability);
